import { DotsThreeOutlineVertical } from "@phosphor-icons/react";
import {
  IconButton,
  DropdownMenu,
  Grid,
  Box,
  Card,
  Flex,
  Text,
} from "@radix-ui/themes";
import { Link as NavLink } from "@tanstack/react-router";
import cx from "classnames";
import { formatDistanceToNow } from "date-fns";

import { ticketsRoute } from "../../tickets/route";

export function WorkflowReviewCard(props: {
  _id: string;
  name: string;
  thumbnails: string[];
  updatedAt: Date;
  totalFiles: number;
  handleOpenFolder?: (folderId: string) => void;
  onDeleteFolder?: (folderId: string) => void;
  onRenameFolder?: (folderId: string) => void;
  onShareFolder?: (folderId: string) => void;
  onDownloadFolder?: (folderId: string) => void;
  showActions?: boolean | undefined;
}) {
  const {
    _id,
    name,
    thumbnails,
    updatedAt,
    totalFiles,
    handleOpenFolder,
    onDeleteFolder,
    onRenameFolder,
    onShareFolder,
    onDownloadFolder,
    showActions = true,
  } = props;

  const _thumbnailUrl = thumbnails[0];

  return (
    <Card
      className="grid h-[107px] w-[284px] gap-2"
      onDoubleClick={() => handleOpenFolder?.(_id)}
    >
      <Flex gap="4">
        <Grid gap="1" className="flex-1" align="start">
          <Flex gap="1" justify="between" align="center">
            <NavLink
              to={ticketsRoute.to}
              search={{ folderId: _id, view: "workflow" }}
              className="puntt-link truncate"
              onClick={(e) => {
                if (e.metaKey || e.ctrlKey || e.shiftKey) {
                  return;
                }
                handleOpenFolder?.(_id);
              }}
            >
              {name}
            </NavLink>

            <DropdownMenu.Root>
              <DropdownMenu.Trigger className={cx({ hidden: !showActions })}>
                <IconButton size="1" variant="ghost" color="gray">
                  <DotsThreeOutlineVertical />
                </IconButton>
              </DropdownMenu.Trigger>

              <DropdownMenu.Content>
                <DropdownMenu.Item
                  onClick={() => {
                    onShareFolder?.(_id);
                  }}
                >
                  Share
                </DropdownMenu.Item>
                <DropdownMenu.Item
                  onClick={() => {
                    onRenameFolder?.(_id);
                  }}
                >
                  Rename
                </DropdownMenu.Item>
                <DropdownMenu.Item
                  onClick={() => {
                    onDownloadFolder?.(_id);
                  }}
                >
                  Download
                </DropdownMenu.Item>
                <DropdownMenu.Item
                  onClick={() => {
                    onDeleteFolder?.(_id);
                  }}
                >
                  Delete
                </DropdownMenu.Item>
              </DropdownMenu.Content>
            </DropdownMenu.Root>
          </Flex>
          <Flex gap="4">
            <Box
              className={cx("relative aspect-video h-[52px] max-w-[92px]", {
                hidden: !_thumbnailUrl,
              })}
            >
              {totalFiles > 1 && (
                <Box className="absolute left-1 top-1 size-full border border-puntt-neutral-grayA-6"></Box>
              )}
              <img
                src={_thumbnailUrl}
                alt={`${name} thumbnail`}
                className="relative size-full border border-puntt-neutral-grayA-6 object-cover"
              />
            </Box>
            <Grid gap="2">
              <Text size="1" color="gray">
                {totalFiles} file{totalFiles === 1 ? "" : "s"}
              </Text>
              <Flex gap="1" justify="between" align="center">
                <Text size="1" color="gray">
                  {formatDistanceToNow(updatedAt as Date)} ago
                </Text>
              </Flex>
            </Grid>
          </Flex>
        </Grid>
      </Flex>
    </Card>
  );
}
